// Convert string to Title format
export function toTitleCase(str) {
	return str?.replace(/\b\w+/g, function (s) {
		return s.charAt(0).toUpperCase() + s.substr(1).toLowerCase();
	});
}
